// extracted by mini-css-extract-plugin
module.exports = {"container":"main-content_container__v_mAS","title":"main-content_title__hUH21","section":"main-content_section__8ulKq","imageSection":"main-content_imageSection__6SImi"};